import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ea9566b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new-profile-card custom-bg rounded-2 p-3" }
const _hoisted_2 = { class: "new-profile-content d-flex align-items-center gap-4" }
const _hoisted_3 = { class: "avatar-wrapper overflow-hidden flex-shrink-0 rounded-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "main-info flex-grow-1" }
const _hoisted_6 = {
  class: "text-white fw-bold",
  style: {"font-size":"20px"}
}
const _hoisted_7 = {
  key: 0,
  src: "/favicon.png",
  alt: "Crown Icon"
}
const _hoisted_8 = { class: "meta-row d-flex flex-wrap align-items-center gap-3" }
const _hoisted_9 = {
  key: 0,
  class: "subscription-chip d-flex justify-content-center align-items-center rounded-1 lh-1 fw-bold"
}
const _hoisted_10 = {
  key: 1,
  href: "/profile/billing",
  class: "subscription-chip d-flex justify-content-center align-items-center upgrade-link rounded-1 lh-1 fw-bold"
}
const _hoisted_11 = { class: "patent-text fw-semibold" }
const _hoisted_12 = { class: "xp-text fw-bold" }
const _hoisted_13 = { class: "profile-side d-flex align-items-center gap-3 ms-auto" }
const _hoisted_14 = { class: "level-block" }
const _hoisted_15 = { class: "level-title text-white fw-bold mb-2" }
const _hoisted_16 = { class: "missing-xp small mt-2 mb-0" }
const _hoisted_17 = {
  key: 0,
  href: "/profile/overview",
  class: "manage-profile-btn btn rounded-2 fw-bold"
}

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import ProgressBar from "@/modern/components/ui/ProgressBar.vue";
import TextScrambleLoader from "@/modern/components/ui/TextScrambleLoader.vue";
import type { IPublicUser, IUser, ModernUser, ModernUserPatent } from "@/modern/types/dashboard";


export default /*#__PURE__*/_defineComponent({
  props: {
    user: null,
    userPublic: null,
    userPatent: null,
    currentLanguage: null
  },
  setup(__props: any) {

const props = __props as {
	user: IUser;
	userPublic: IPublicUser;
	userPatent: ModernUserPatent;
	currentLanguage: string;
}



const { t } = useI18n();

const hasFeature = (feature: string) => Boolean(props.user?.features?.includes(feature));

const scoreLevel = (value: number | null | undefined) => {
	if (typeof value !== "number" || !value) {
		return { level: 0, xp: 0 };
	}

	const level = Math.floor(value / 1000);
	const xp = value % 1000;

	return {
		level: level < 1 ? 0 : level,
		xp,
	};
};

const scoreInfo = computed(() => scoreLevel(props.userPublic?.score?.value));
const totalScore = computed(() => Number(props.userPublic?.score?.value ?? 0));
const xpToNextLevel = computed(() => 1000 - scoreInfo.value.xp);
const hasScoreData = computed(() => typeof props.userPublic?.score?.value === "number");
const hasPatentData = computed(() => Boolean(props.userPatent?.name));
const displayName = computed(() => props.user?.nick || props.user?.name || "No nick");
const subscriptionLabel = computed(() => (hasFeature("elite") ? "ELITE" : "PRO"));

const tKey = (key: string, params: Record<string, unknown> = {}) => t(`${props.currentLanguage}.${key}`, params);
const subscriberLabel = computed(() => `${tKey("profile.subscriber")} ${subscriptionLabel.value}`);
const xpToNextLevelLabel = computed(() => tKey("profile.xp_to_next_level", { n: xpToNextLevel.value }));
const xpToNextLevelPlaceholder = computed(() => tKey("profile.xp_to_next_level", { n: "..." }));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: props.user?.avatar || '/media/avatars/blank.png',
          class: "avatar-image w-100 h-100",
          alt: "avatar"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", _hoisted_6, [
          _createTextVNode(_toDisplayString(_unref(displayName)) + " ", 1),
          (hasFeature('elite'))
            ? (_openBlock(), _createElementBlock("img", _hoisted_7))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (hasFeature('full_access'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(subscriberLabel)), 1))
            : (_openBlock(), _createElementBlock("a", _hoisted_10, _toDisplayString(_unref(t)(`${__props.currentLanguage}.checkout.upgrade_your_plan`)), 1)),
          _createElementVNode("span", _hoisted_11, [
            _createVNode(TextScrambleLoader, {
              loading: !_unref(hasPatentData),
              "resolved-text": __props.userPatent?.name ?? '',
              placeholder: tKey('profile.next_rank')
            }, null, 8, ["loading", "resolved-text", "placeholder"])
          ]),
          _createElementVNode("span", _hoisted_12, [
            _createTextVNode(_toDisplayString(tKey('profile.total_xp')) + ": ", 1),
            _createElementVNode("strong", null, [
              _createVNode(TextScrambleLoader, {
                loading: !_unref(hasScoreData),
                "resolved-text": _unref(totalScore),
                placeholder: "000000"
              }, null, 8, ["loading", "resolved-text"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("p", _hoisted_15, [
            _createTextVNode(_toDisplayString(tKey('profile.level')) + ": ", 1),
            _createElementVNode("span", null, [
              _createVNode(TextScrambleLoader, {
                loading: !_unref(hasScoreData),
                "resolved-text": _unref(scoreInfo).level,
                placeholder: "00"
              }, null, 8, ["loading", "resolved-text"])
            ])
          ]),
          _createVNode(ProgressBar, {
            value: _unref(scoreInfo).xp,
            max: 1000,
            variant: "xp",
            color: "new-profile-progress"
          }, null, 8, ["value"]),
          _createElementVNode("p", _hoisted_16, [
            _createVNode(TextScrambleLoader, {
              loading: !_unref(hasScoreData),
              "resolved-text": _unref(xpToNextLevelLabel),
              placeholder: _unref(xpToNextLevelPlaceholder)
            }, null, 8, ["loading", "resolved-text", "placeholder"])
          ])
        ]),
        (__props.user.id)
          ? (_openBlock(), _createElementBlock("a", _hoisted_17, _toDisplayString(tKey('profile.manage_profile')), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})